import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";
import moment from "moment";

const API_URL = config.API_URL;

const create = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    if (["gender"].includes(value) && values[value] && typeof values[value] === "object") {
      formData.append(value, values[value].value);
    } else if (["date_of_birth"].includes(value)) {
      let dateoftime = values[value] ? moment(values[value].replace(/\//g, "-"), "DD-MM-YYYY").format("YYYY-MM-DD") : "";
      formData.append(value, dateoftime);
    } else if(["gender"].includes(value)){
      values[value] ? formData.append(value, values[value]) : ""
    }else{
      formData.append(value, values[value]);
    }
  }
  const action = "afterlogin/client/store";
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const update = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    if (["gender"].includes(value) && values[value] && typeof values[value] === "object") {
      formData.append(value, values[value].value);
    } else if (["date_of_birth"].includes(value)) {
      let dateoftime = values[value] ? moment(values[value].replace(/\//g, "-"), "DD-MM-YYYY").format("YYYY-MM-DD") : "";
      formData.append(value, dateoftime);
    } else {
      formData.append(value, values[value]);
    }
  }
  const action = "afterlogin/client/update/" + values.id;
  formData.append("auth_key", auth_key);
  formData.append("action", action);

  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const view = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const sort = values && values.sort;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  const result = values && values.result ? values.result : "";
  let sortstring = "";
  if (sort) {
    let sortArray = [];
    Object.keys(sort).map(function (key, index) {
      sortArray[index] = `sort[${key}]=${sort[key]}`;
    });
    if (sortArray.length > 0) {
      let jsort = sortArray.join("&");
      sortstring = jsort;
    }
  }
  let pagination = true;
  if (values) {
    if (values.id) {
      pagination = false;
    }
    if (values.option) {
      pagination = false;
    }
    if (values.pagination) {
      pagination = values.pagination;
    }
  }
  const action = page ? `afterlogin/client/view?page=${page}&${sortstring}` : `afterlogin/client/view?${sortstring}`;
  const data = {
    auth_key: auth_key,
    action: action,
    pagination: pagination, //true or false
    id: values && values.id ? values.id : "",
    result: result, //business_name,owner_name
  };
  return axios.post(next_page_url ? `${next_page_url}&${sortstring}` : API_URL + action, data, { headers: authHeader() });
};

const deleted = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/client/delete/${values.id}`;
  const data = {
    auth_key: auth_key,
    action: action,
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const mergeList = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/client/mergeList`;
  const data = {
    auth_key: auth_key,
    action: action,
    exclude_id: values && values.exclude_id ? values.exclude_id : "",
    page: values && values.page ? values.page : 1,
    per_page: values && values.per_page ? values.per_page : 10,
    q: values && values.q ? values.q : "",
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const mergeClients = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/client/merge`;
  const data = {
    auth_key: auth_key,
    action: action,
    main_client_id: values.main_client_id,
    merge_client_ids: values.merge_client_ids,
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const suggetionlist = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  let q = values && values.q ? values.q : "";
  const action = page ? `afterlogin/client/view?page=${page}&q=${q}` : `afterlogin/client/view?q=${q}`;
  const data = {
    auth_key: auth_key,
    action: action,
    pagination: true, //true or false
    id: values && values.id ? values.id : "",
    suggetion_match : values && values.suggetion_match ? values.suggetion_match : "",
    apicall: "suggetion",
  };
  return axios.post(next_page_url ? `${next_page_url}&q=${q}` : API_URL + action, data, { headers: authHeader() });
};

const clientimport = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/client/clientimport`;
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value]);
  }
  // formData.append("excelfile", values.excelfile);
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};
const clientexport = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/client/clientexport`;
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value]);
  }
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader() });
};

const clientmailchimpsync = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/client/clientmailchimp`;
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value]);
  }
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader() });
};

const clientvoucherimport = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/client/clientimportvoucher`;
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value]);
  }
  // formData.append("excelfile", values.excelfile);
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const clientvouchersample = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `common/sampleclientvoucherexport`;
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value]);
  }
  // formData.append("excelfile", values.excelfile);
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const clientvoucherexports = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `common/sampleclientvoucherexport`;
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value]);
  }
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader() });
};

const clientApiController = {
  create,
  view,
  mergeList,
  mergeClients,
  update,
  deleted,
  suggetionlist,
  clientimport,
  clientexport,
  clientmailchimpsync,
  clientvoucherimport,
  clientvouchersample,
  clientvoucherexports
};
export default clientApiController;
